<template>

    <div class="product-buy" :class="{ 'product-buy--logged-in': loggedIn || inKioskApp }">
        <transition name="fade">
            <add-to-cart-modal v-if="$store.getters.showModal('addToCart')"
                :style="`z-index: ${ 200 + $store.getters.modalZDepth('addToCart')}`"
                @load-cart="loadCart"
                v-cloak>
            </add-to-cart-modal>
        </transition>

        <transition name="fade">
            <alternatives-modal v-if="$store.getters.showModal('alternatives')"
                :style="`z-index: ${ 200 + $store.getters.modalZDepth('alternatives')}`"
                @add-to-cart="addToCart"
                @add-to-order="addToOrder"
                v-cloak>
            </alternatives-modal>
        </transition>

        <template v-if="loggedIn || inKioskApp">
            <span class="product-buy__price" v-if="price > 0" :class="{ 'text-green-500': isPromo }">
                <span v-if="isPromo" class="block text-12">{{ $t('Promo tem') }} {{ promoUntil }}</span>
                {{ formatCurrency(price) }}
            </span>
            <div v-if="showVolumeDiscounts && volumeDiscounts.length" class="product-buy__volume">
                <button class="product-buy__volume-button"
                        v-for="volumeDiscount in volumeDiscounts"
                        v-if="volumeDiscount.quantityAmountFrom > 0"
                        @click.prevent="updateQty(false, product, (volumeDiscount.quantityAmountTo < 99999) ? volumeDiscount.quantityAmountFrom : (volumeDiscount.quantityAmountFrom))"
                >
                    <span v-if="volumeDiscount.quantityAmountFrom > 0 && volumeDiscount.quantityAmountTo < 99999"
                          v-html="$t('volumeDiscountText', { qty: volumeDiscount.quantityAmountFrom, price: formatCurrency(volumeDiscount.amount) })"></span>
                    <span v-else
                          v-html="$t('volumeDiscountTextMore', { qty: (volumeDiscount.quantityAmountFrom), price: formatCurrency(volumeDiscount.amount) })"></span>
                </button>
            </div>
            <div class="product-buy__controls">
                <form class="form-add-to-cart" :class="{ 'in-backorder': isInBackorder }">
                    <div class="form-add-to-cart__input-wrapper">
                        <label for="qty" class="sr-only">{{ $t("Aantal") }}</label>
                        <input type="number"
                               class="form-add-to-cart__input qty"
                               id="qty"
                               name="qty"
                               :min="getMinQty(product.multiples)"
                               :step="getStepQty(product.multiples)"
                               :value="getProductQty(product.id, product.multiples)"
                               :disabled="!user"
                               @change="updateQty($event, product)"/>

                        <button v-if="isSales"
                                @click.prevent="addProductToCartModal(product)"
                                :disabled="!user"
                                class="form-add-to-cart__button">
                            <span class="fas fa-pen" aria-hidden="true"></span>
                        </button>

                        <button @click.prevent="addProductToCart(product)"
                                :disabled="!user"
                                class="form-add-to-cart__button form-add-to-cart__button--filled">
                            <span class="fas fa-shopping-basket" aria-hidden="true"></span>
                        </button>
                    </div>

                    <button v-if="!isSales && loggedIn" class="form-add-to-cart__button form-add-to-cart__button--favorite"
                            :class="{ 'form-add-to-cart__button--filled': userFavorites.includes(parseInt(product.id)) }"
                            @click.prevent="toggleFavorite(product.id)"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                            <path d="M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2L443 275.5c23.6-22 37-52.8 37-85.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zm34.9-57.1C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 36-13.1 70.6-36.6 97.5c-3.4 3.8-6.9 7.5-10.7 11l-184 171.3c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5z"/>
                        </svg>
                    </button>
                </form>
            </div>
        </template>
        <template v-else>
            <a :href="loginUrl" class="btn">
                {{ $t("Log in to order") }}
            </a>
        </template>
    </div>
</template>

<script>
import {helpers} from "@/js/mixins/helpers.js"
import AddToCartModal from "./AddToCartModal"
import AlternativesModal from "./AlternativesModal"
import Vue from "vue"
import {mapState} from "vuex"

import algoliasearch from "algoliasearch/lite"
import instantsearch from 'instantsearch.js'
import searchInsights from 'search-insights'
import {createInsightsMiddleware} from 'instantsearch.js/es/middlewares'

const searchClient = algoliasearch('VOYNA2HOMW', 'a40c9abd596160f234d82e9c7bf3597b')
const search = instantsearch({
    indexName: `products_${window.language}`,
    searchClient
})

const insightsMiddleware = createInsightsMiddleware({
    insightsClient: searchInsights
})

search.use(insightsMiddleware)

export default {
    name: "ProductBuy",
    mixins: [helpers],
    components: {AddToCartModal, AlternativesModal},

    props: {
        // If it is a directOrder items are added to the cart. If not, they are added to a saved order.
        user: {
            type: [Array, Object, Boolean],
            default: null
        },
        loggedIn: {
            type: Boolean,
            default: false,
        },
        inSalesApp: {
            type: Boolean,
            default: true,
        },
        inKioskApp: {
            type: Boolean,
            default: false,
        },
        isSales: {
            type: Boolean,
            default: false,
        },
        product: {
            type: [Array, Object, Boolean],
            default: null
        },
        redirect: {
            type: String,
            default: null
        },
        isPromo: {
            type: Boolean,
            default: false
        },
        promoUntil: {
            type: String | Boolean,
            default: null
        },
        isInBackorder: {
            type: Boolean,
            default: false
        },
        algoliaQueryId: {
            type: [String, Number],
            default: null
        },
        loginUrl: {
            type: String,
            default: '/login'
        },
        favoriteProductIds: {
            type: Array,
            default: () => []
        },
        showVolumeDiscounts: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            // ON/OFF switch pricing API
            enablePricingAPI: true,

            productsInOrder: [],
            oldPrice: 0,
            price: 0,
            userFavorites: [],
            volumeDiscounts: [],
        }
    },

    mounted() {
        // Add Algolia userToken for Algolia Insights
        searchInsights('setUserToken', this.algoliaUserToken)

        // Disable pricingAPI when not logged in
        this.enablePricingAPI = !!this.user

        // Empty current products for certainty
        this.productsInOrder = []

        // Add favorites to data
        this.userFavorites = this.favoriteProductIds

        // Show products that are in the cart
        this.$store.dispatch('loadCart').then(result => {
            if (result && result.lineItems) this.productsInOrder = this.mapLineItemsToProducts(result.lineItems)
        })

    },

    created() {
        if (this.loggedIn || this.inKioskApp) {
            this.getPriceForProduct(this.product, 1).then(data => {
                if (data) {
                    this.price = data.price
                    this.volumeDiscounts = data.volumeDiscounts
                    Vue.set(this.product, 'defaultPrice', data.price)
                } else {
                    this.price = this.product.defaultPrice
                }
            })
        }
    },

    methods: {
        addProductToCartModal(product) {
            this.checkForAlternatives(product).then(result => {
                if (result) this.addToCartModal(product)
            })
        },

        addProductToCart(product) {
            this.checkForAlternatives(product).then(result => {
                if (result) this.addToCart(product)
            })
        },

        addToCart(currentProduct) {
            console.log(currentProduct)
            // Check if product is already added by changing the quantity, if not, add it to the list
            let product = this.isProductInOrder(currentProduct.id) ?? this.addToOrder(currentProduct, currentProduct.qty)

            if (product) {
                // Check if there is an updated price available
                const price = currentProduct.defaultPrice

                window.axios({
                    url: `${window.rootUrl}actions/commerce/cart/update-cart`,
                    method: 'POST',
                    data: {
                        purchasableId: product.purchasableId,
                        qty: product.qty,
                    }
                }).then(result => {
                    if (result.status === 200) {
                        // Show notification
                        this.$notify({
                            text: window.i18n.t("success.addedToCart"),
                            type: "success",
                        })

                        // Save cart
                        if (result?.data?.cart) {
                            this.$store.dispatch('saveCart', result.data.cart)
                        }

                        // Show highlight products in cart
                        if (result?.data?.cart?.lineItems) {
                            const lineItems = result.data.cart.lineItems
                            this.productsInOrder = this.mapLineItemsToProducts(lineItems)
                        }

                        // Send Algolia event
                        if (this.algoliaQueryId) {
                            searchInsights('convertedObjectIDsAfterSearch', {
                                index: `products_${window.language}`,
                                eventName: 'Product added to cart.',
                                queryID: this.algoliaQueryId,
                                objectIDs: [currentProduct.id.toString()],
                            })
                        }

                        // Reset qty for the added product
                        //this.updateQty(null, currentProduct, 1)
                    } else {
                        this.$notify({
                            title: window.i18n.t("errors.generalTitle"),
                            text: window.i18n.t("errors.notAddedToCart"),
                            type: "error",
                        })
                        console.error("Cart error.", result)
                    }
                }).catch((error) => {
                    this.$notify({
                        title: window.i18n.t("errors.generalTitle"),
                        text: window.i18n.t("errors.cartNotUpdated"),
                        type: "error",
                    })
                    console.error("Cart error.", error)
                })
            }
        },

        getAlternativeProducts(id) {
            // No user facing error messages, because we don't want to stop the order if there is a POSSIBLE alternative issue
            const inventSiteId = this.user?.inventSiteId ?? '01' // 01 = default warehouse

            return window.axios({
                url: `${window.rootUrl}api/product/alternatives/${id}.json?inventSiteId=${inventSiteId}`,
                method: 'GET'
            }).then(result => {
                if (result.status === 200 && result?.data?.alternatives) {
                    return result.data.alternatives
                } else {
                    console.error("Could not retrieve alternative products.", error)
                    return null
                }
            }).catch((error) => {
                console.error("Could not retrieve alternative products.", error)
                return null
            })
        },

        async checkForAlternatives(product) {
            const productAlternatives = await this.getAlternativeProducts(product.id)
                .then(data => data)
                .catch(error => {
                    console.error("Error while fetching product alternatives.", error)
                    return null
                })

            if (productAlternatives && productAlternatives.length) {
                // Get chosen quantity -> if it was already changed the product will be in the productOrder list else we order 1
                const productInOrder = this.isProductInOrder(product.id)
                const qty = productInOrder ? productInOrder.qty : 1

                // Alternatives found
                await this.$store.dispatch(
                    'toggleModal',
                    {
                        name: 'alternatives',
                        data: {
                            alternatives: productAlternatives.map(a => a.product),
                            isSales: this.isSales,
                            directOrder: this.directOrder,
                            chosenQuantity: qty
                        }
                    }
                )

                return false
            } else if (productAlternatives) {
                return true
            } else {
                // Error occurred (productAlternatives is null)
                this.$notify({
                    title: window.i18n.t("errors.generalTitle"),
                    text: window.i18n.t("errors.notAddedToCart"),
                    type: "error"
                })
                console.error("Error while fetching product alternatives.")

                return false
            }
        },

        isProductInOrder(id) {
            return this.productsInOrder.find(product => parseInt(product.id) === parseInt(id))
        },

        loadCart(lineItems) {
            // Used within addToCartModal, if a product is added to the cart there, we need to update the list here
            this.productsInOrder = this.mapLineItemsToProducts(lineItems)
        },

        updateQty(event, currentProduct, quantity) {

            const qty = event ? parseInt(event.target.value) : quantity
            let id = currentProduct.hasOwnProperty('objectID') ? currentProduct.objectID : currentProduct.id

            // First get the form
            const form = document.querySelector('.form-add-to-cart')
            // Now get the buttons in the form
            const buttons = form.querySelectorAll('button')

            // Check for mandatory multiples
            if (event && currentProduct.multiples.length) {

                let step = parseInt(event.target.step)
                let min = parseInt(event.target.min)

                if (qty < min) {
                    this.$notify({
                        text: window.i18n.t("errors.minQtyError", {min}),
                        type: "error",
                    })

                    // Disable buttons
                    buttons.forEach(el => {
                        el.disabled = true
                    })

                    return false
                }

                if ((qty % step) !== 0) {
                    this.$notify({
                        text: window.i18n.t("errors.stepQtyError", {step}),
                        type: "error",
                    })

                    // Disable buttons
                    buttons.forEach(el => {
                        el.disabled = true
                    })

                    return false
                }
            }

            this.getPriceForProduct(currentProduct, qty).then(data => {
                if (data) {
                    this.price = data.price
                    Vue.set(this.product, 'defaultPrice', data.price)
                } else {
                    this.price = this.product.defaultPrice
                }
            })

            // Enabled buttons
            // Disable buttons
            buttons.forEach(el => {
                el.removeAttribute('disabled')
            })

            // Check if product was already added
            const product = this.isProductInOrder(parseInt(id))
            if (product) {
                // Product exists
                if (qty > 0) {
                    // Qty > 0 -> Update quantity
                    product.qty = qty
                }
            } else {
                // Product does not exist -> add it to order with correct qty (to store qty info)
                this.addToOrder(currentProduct, qty)
            }
        },

        getMinQty(multiples) {
            if (multiples) {
                // Check if customer is linked to one of the inventSiteId's
                // in the object
                const inventSiteId = this.user?.inventSiteId ?? ''

                const specificMultiple = multiples.filter((el) => el.inventSiteId == inventSiteId)
                const globalMultiple = multiples.filter((el) => el.inventSiteId == '' || el.inventSiteId == null)

                if (specificMultiple.length) {
                    return (specificMultiple[0].lowestQty > 0) ? specificMultiple[0].lowestQty : 1
                }

                if (globalMultiple.length) {
                    return (globalMultiple[0].lowestQty > 0) ? globalMultiple[0].lowestQty : 1
                }

            } else {
                return 1
            }
        },

        getStepQty(multiples) {
            if (multiples) {
                // Check if customer is linked to one of the inventSiteId's
                // in the object
                const inventSiteId = this.user?.inventSiteId ?? ''

                const specificMultiple = multiples.filter((el) => el.inventSiteId == inventSiteId)
                const globalMultiple = multiples.filter((el) => el.inventSiteId == '' || el.inventSiteId == null)

                if (specificMultiple.length) {
                    return (specificMultiple[0].multipleQty > 0) ? specificMultiple[0].multipleQty : 1
                }

                if (globalMultiple.length) {
                    return (globalMultiple[0].multipleQty > 0) ? globalMultiple[0].multipleQty : 1
                }

            } else {
                return 1
            }
        },

        getProductQty(id, multiples) {
            const product = this.isProductInOrder(id)
            if (product) return product.qty
            if (multiples) {
                // Check if customer is linked to one of the inventSiteId's
                // in the object
                const inventSiteId = this.user?.inventSiteId ?? ''

                const specificMultiple = multiples.filter((el) => el.inventSiteId == inventSiteId)
                const globalMultiple = multiples.filter((el) => el.inventSiteId == '' || el.inventSiteId == null)

                if (specificMultiple.length) {
                    return (specificMultiple[0].lowestQty > 0) ? specificMultiple[0].lowestQty : 1
                }

                if (globalMultiple.length) {
                    return (globalMultiple[0].lowestQty > 0) ? globalMultiple[0].lowestQty : 1
                }
            }
            return 1
        },

        mapLineItemsToProducts(lineItems) {
            return lineItems.map(lineItem => {
                return {
                    rowId: null,
                    id: parseInt(lineItem.snapshot.product.id),
                    purchasableId: parseInt(lineItem.purchasableId),
                    title: lineItem.description,
                    defaultPrice: lineItem.price,
                    qty: 1, // Always start from quantity 1 for items in cart
                    type: 'lineItem' // Used to differentiate between order products and lineItems for highlighting correct products depending on directOrder
                }
            })
        },

        addToOrder(currentProduct, quantity) {
            let id = currentProduct.id
            const product = {
                rowId: null,
                id: parseInt(id),
                purchasableId: parseInt(currentProduct.defaultVariantId),
                title: currentProduct.title,
                defaultPrice: currentProduct.defaultPrice,
                qty: quantity ?? currentProduct.qty ?? 1,
                type: currentProduct.type ?? ''
            }

            // Products from alternative modal have type == saved
            if (!this.isProductInOrder(parseInt(id))) {
                /* Product not in array: 2 possibilities
                 * 1: Add button clicked with qty == 1 -> set saved type
                 * 2: Quantity changed -> qty always > 1 -> not yet saved -> don't set type
                 */
                if (product.qty === 1) product.type = 'saved'
                this.productsInOrder.push(product)
            } else {
                // Product already in order -> qty was already set and now add button is clicked
                let existingProduct = this.isProductInOrder(parseInt(id))
                existingProduct.type = 'saved'
            }

            this.$emit('update-order', this.productsInOrder)

            return product
        },

        addToCartModal(product) {
            const item = this.isProductInOrder(product.id)

            const addToCartProduct = {
                sku: product.defaultSku,
                purchasableId: product.defaultVariantId,
                qty: item ? item.qty : 1,
                defaultPrice: parseFloat(product.defaultPrice) ?? 0,
                redirect: this.redirect,
                multiples: product.multiples
            }

            this.$store.dispatch('toggleModal', {name: 'addToCart', data: addToCartProduct})
        },

        async getPriceForProduct(product, qty) {

            if (!this.enablePricingAPI) return product.defaultPrice

            let result
            try {
                result = await window.axios.post(
                    '/actions/ranson-module/customer/price',
                    {
                        useDb: false,
                        itemId: product.defaultSku,
                        customer: this.user ? this.user.id : null,
                        qty: qty,
                        requestedDeliveryDate: this.user && this.user.deliveryDates ? this.user.deliveryDates[0].date : null
                    }
                )

                if (result && result.status === 200) {
                    return result.data
                } else {
                    // Price === 0 throws error too
                    console.error("Could not retrieve price for product.", result)
                    return null
                }
            } catch (error) {
                if (error.name === 'AbortError') {
                    console.warn('Fetch aborted')
                } else {
                    console.error('Fetch error:', error)
                }
            }
        },

        toggleFavorite(objectId) {
            fetch('/actions/ranson-module/customer/toggle-favorite', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': window.csrfToken
                },
                body: JSON.stringify({
                    productId: objectId
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        if (this.userFavorites.includes(parseInt(objectId))) {
                            this.userFavorites = this.userFavorites.filter(id => parseInt(id) !== parseInt(objectId))
                        } else {
                            this.userFavorites.push(parseInt(objectId))
                        }

                        this.$notify({
                            text: data.message,
                            type: "success",
                        });

                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    this.$notify({
                        text: 'Could not add favorite. Please try again later.',
                        type: "success",
                    });

                });
        },
    },

    computed: {
        ...mapState([
            'algoliaUserToken'
        ])
    }
}
</script>
